<template>
  <div>
    <Navigation/>
    <img :src="imgUrl" alt="" class="banner">
    <div class="ct_box">
      <div class="nav flex">
        <img @click="handleMouseEnter(0)"
             :src="title === 0 ? require('../assets/guide/title0_hover.png') : require('../assets/guide/title0.png')"
             alt="" class="title">
        <img @click="handleMouseEnter(1)"
             :src="title === 1 ? require('../assets/guide/title1_hover.png') : require('../assets/guide/title1.png')"
             alt="" class="title">
        <img @click="handleMouseEnter(2)"
             :src="title === 2 ? require('../assets/guide/title2_hover.png') : require('../assets/guide/title2.png')"
             alt="" class="title">

      </div>
      <ul class="list" v-show="title === 0">
        <li class="flex" v-for="(item, index) in vadeList2" :key="index" @click="goDetail(item)">
          <p class="img_box flex">
            <img :src="item.image" alt="">
          </p>
          <div class="ct_box">
            <h4>{{ item.title }}</h4>
            <p v-html="item.des + '...'"></p>
            <!-- <span>阅读量:{{ item.reading }}</span> -->
          </div>
          <div class="day_box">
            <p class="year">{{ item.ym }}</p>
            <p class="day">{{ item.d }}</p>
          </div>
        </li>
      </ul>
      <ul class="list" v-show="title === 1">
        <li class="flex" v-for="(item, index) in vadeList3" :key="index" @click="goDetail(item)">
          <p class="img_box flex">
            <img :src="item.image" alt="">
          </p>
          <div class="ct_box">
            <h4>{{ item.title }}</h4>
            <p v-html="item.des + '...'"></p>
            <!-- <span>阅读量:{{ item.reading }}</span> -->
          </div>
          <div class="day_box">
            <p class="year">{{ item.ym }}</p>
            <p class="day">{{ item.d }}</p>
          </div>
        </li>
      </ul>
      <ul class="list" v-show="title === 2">
        <li class="flex" v-for="(item, index) in vadeList4" :key="index" @click="goDetail(item)">
          <p class="img_box flex">
            <img :src="item.image" alt="">
          </p>
          <div class="ct_box">
            <h4>{{ item.title }}</h4>
            <p v-html="item.des + '...'"></p>
            <!-- <span>阅读量:{{ item.reading }}</span> -->
          </div>
          <div class="day_box">
            <p class="year">{{ item.ym }}</p>
            <p class="day">{{ item.d }}</p>
          </div>
        </li>
      </ul>
    </div>
    <!-- 分页器 -->
    <pagination style="padding: 30px" v-show="title === 0" :page="page0" @pageChange="pageChange" :count="count0"
                :total_page="total_page0"/>
    <pagination style="padding: 30px" v-show="title === 1" :page="page1" @pageChange="pageChange" :count="count1"
                :total_page="total_page1"/>
    <pagination style="padding: 30px" v-show="title === 2" :page="page2" @pageChange="pageChange" :count="count2"
                :total_page="total_page2"/>

  </div>
</template>

<script>
export default {
  name: '',
  created() {
  },
  mounted() {
    this.guideFn_0()
    if (this.$route.query.show) {
      this.title = this.$route.query.show
    }
    this.BannerImgFn()
  },
  data() {
    return {
      title: 0,
      vadeList2: [],
      vadeList3: [],
      vadeList4: [],
      imgUrl: '',
      page0: 1,
      page1: 1,
      page2: 1,
      total_page0: '',
      total_page1: '',
      total_page2: '',
      count0: '',
      count1: '',
      count2: '',
    }
  },
  methods: {
    guideFn_0() {
      this.curlGet('/api/index/index_guide', {
        limit: 10,
        page: this.page0,
        catid: 2
      }).then(res => {
        console.log('111', res)
        if (res.data.code) {
          this.vadeList2 = res.data.data.list
          this.count0 = res.data.data.count
          this.total_page0 = res.data.data.total_page
        }
      })
    },
    guideFn_1() {
      this.curlGet('/api/index/index_guide', {
        limit: 10,
        page: this.page1,
        catid: 3
      }).then(res => {
        if (res.data.code) {
          this.vadeList3 = res.data.data.list
          this.count1 = res.data.data.count
          this.total_page1 = res.data.data.total_page
        }
      })
    },
    guideFn_2() {
      this.curlGet('/api/index/index_guide', {
        limit: 10,
        page: this.page2,
        catid: 4
      }).then(res => {
        if (res.data.code) {
          this.vadeList4 = res.data.data.list
          this.count2 = res.data.data.count
          this.total_page2 = res.data.data.total_page
        }
      })
    },
    pageChange(pageVal) {
      // this.page = pageVal
      if (this.title === 0) {
        this.page0 = pageVal
        this.guideFn_0()
      }
      if (this.title === 1) {
        this.page1 = pageVal
        this.guideFn_1()
      }
      if (this.title === 2) {
        this.page2 = pageVal
        this.guideFn_2()
      }

    },
    handleMouseEnter(index) {
      this.title = index
      if (this.title === 0) {
        this.guideFn_0()
      }
      if (this.title === 1) {
        this.guideFn_1()
      }
      if (this.title === 2) {
        this.guideFn_2()
      }
    },
    goDetail(item) {
      this.$router.push({
        path: '/GuideDetail',
        query: {
          id: item.id
        },
      })
    },
    BannerImgFn() {
      this.curlGet('/api/advert/detail', {
        mark: 'guide_banner_01'
      }).then(res => {
        if (res.data.code) {
          this.imgUrl = res.data.data.image
        }
      })
    },
  },
}
</script>

<style lang=scss scoped>
@use '@/scss/Guide';
</style>